const primary = {
    A00: '#0E253A',
    A20: '#194166',
    A40: '#194166',
    A60: '#420021',
};

export default primary;
